module.exports = angular.module('cartographer.map.legend', [])

module.exports.directive 'crtAttributeInspector', $DI (crtLog, $timeout) ->
  return {
    restrict: 'A'
    replace: true
    template: require './attribute.tpl.html'
    scope:
      featureLayer   : '=' # crtFeatureLayer
      attributeLayer : '=' # crtAttributeLayer
      buckets        : '=' # crtAttributeBuckets
      features       : '=' # arrayOf (feature)
      selection      : '=' # crtFeatureMapSelection
      inspectorState : '=' # crtMapInspectorState
      onBackClick    : '=' # () -> void
      onOptionsClick : '=' # () -> void
    controllerAs: 'crtAttributeInspector'
    bindToController: true
    controller: $DI ($scope) ->
      crtAttributeInspector = this

      crtAttributeInspector.selectedChart = "histogram"

      crtAttributeInspector.selectChart = (chart) ->
        crtAttributeInspector.selectedChart = chart
        return

      crtAttributeInspector.chartsEnabled = ->
        crtAttributeInspector.attributeLayer != null && ( # are we viewing the legend panel
          crtAttributeInspector.histogramEnabled() ||
          crtAttributeInspector.timelineEnabled()
        )

      crtAttributeInspector.histogramEnabled = ->
        crtAttributeInspector.inspectorState.chartsEnabled() &&
        crtAttributeInspector.featureLayer.enableHistogram

      crtAttributeInspector.histogramEmpty = ->
        numBuckets = crtAttributeInspector.buckets.buckets?.length ? 0
        numFeatures = crtAttributeInspector.features?.length ? 0
        numBuckets <= 1 || numFeatures <= 0

      crtAttributeInspector.histogramOverpopulated = ->
        crtAttributeInspector.buckets.buckets.length > 16

      crtAttributeInspector.timelineEnabled = ->
        crtAttributeInspector.inspectorState.chartsEnabled() &&
        crtAttributeInspector.featureLayer.enableTimeline

      crtAttributeInspector.showHistogram = ->
        crtAttributeInspector.chartsEnabled() &&
        crtAttributeInspector.selectedChart == 'histogram'

      crtAttributeInspector.timelineEmpty = ->
        crtAttributeInspector.selection.nearby().length <= 1

      crtAttributeInspector.showTimeline = ->
        crtAttributeInspector.chartsEnabled() &&
        crtAttributeInspector.selectedChart == 'timeline'

      replot = ->
        $timeout(
          ->
            $scope.$broadcast('chart:replot')
            return
          300
        )
        return

      $scope.$watch('crtDataInspector.showHistogram()', replot)
      $scope.$watch('crtDataInspector.showTimeline()', replot)

      return
  }
